import { render, staticRenderFns } from "./AircraftEventTypeLabel.vue?vue&type=template&id=833aad54&scoped=true"
import script from "./AircraftEventTypeLabel.vue?vue&type=script&lang=js"
export * from "./AircraftEventTypeLabel.vue?vue&type=script&lang=js"
import style0 from "./AircraftEventTypeLabel.vue?vue&type=style&index=0&id=833aad54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "833aad54",
  null
  
)

export default component.exports